/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemTreeSetResponseSchema = z.object({
  deletedInItemStore: z.boolean(),
  hasExternalKey: z.boolean(),
  id: z.int(),
  itemTypeId: z.int(),
  loopId: z.int().nullish(),
  matched: z.boolean(),
  parentId: z.int().nullish(),
});
